import React from 'react';
import { mockData } from '../mock';
import { Card, CardContent } from './ui/card';
import { ArrowRight } from 'lucide-react';

const Blog = () => {
  return (
    <section id="blog" className="py-24 bg-[#F5F3ED]">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-6 py-2 bg-white rounded-full text-[#1A3A2E] text-sm font-medium mb-6">
            Blogartikel
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A3A2E] mb-4">
            Informationen zu aktuellen Themen
          </h2>
          <p className="text-lg text-[#1A3A2E]/70 max-w-4xl mx-auto">
            Lesen Sie unsere Tipps und Informationen zu aktuellen Themen zu Heizung, Sanitär, und Lüftung
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {mockData.blogPosts.map((post, idx) => (
            <a
              key={idx}
              href={post.link || '#'}
              target={post.link ? '_blank' : '_self'}
              rel={post.link ? 'noopener noreferrer' : ''}
              className="block"
            >
              <Card
                className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-white px-4 py-2 rounded-full text-[#1A3A2E] text-sm font-medium">
                      {post.category}
                    </span>
                  </div>
                </div>
                <CardContent className="p-8 bg-white">
                  <h3 className="text-xl font-bold text-[#1A3A2E] mb-4 leading-tight group-hover:text-[#2D4A3E] transition-colors">
                    {post.title}
                  </h3>
                  <div className="flex items-center text-[#1A3A2E]/70 group-hover:text-[#1A3A2E] transition-colors">
                    <span>Weiterlesen</span>
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-2 transition-transform" />
                  </div>
                </CardContent>
              </Card>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;